import { render, staticRenderFns } from "./ResultComponent.vue?vue&type=template&id=4dad1fda&scoped=true"
import script from "./ResultComponent.vue?vue&type=script&lang=js"
export * from "./ResultComponent.vue?vue&type=script&lang=js"
import style0 from "./ResultComponent.vue?vue&type=style&index=0&id=4dad1fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dad1fda",
  null
  
)

export default component.exports